import { render, staticRenderFns } from "./ProxyUserBans.vue?vue&type=template&id=62cb8d08&"
import script from "./ProxyUserBans.vue?vue&type=script&lang=ts&"
export * from "./ProxyUserBans.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports